import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import {
  CheckableLabeledImage,
  ImageQuestionGridContainer,
  QuestionErrorMessage,
} from '@nextiva/engagement-ui';
import { compose } from 'recompose';

import StylingTextOptionToRTEProps from 'styling/hocs/StylingToRTEProps/StylingTextOptionToRTEProps';
import withNewKeyOnLocalFontChange from 'styling/hocs/withNewKeyOnLocalFontChange';
import { checkableInputTypes } from 'sharedParts/config/blockConfig/settings/checkableInputTypes';
import { personalLabelProptypes } from 'sharedParts/config/personalLabelMap';

import getSubLabelByType from '../../../../utils/getSubLabelByType';
import getRichContentFromOptionModel from '../../utils/getRichContentFromOptionModel';

class ImageMultiChoiceGroupField extends Component {
  static propTypes = {
    styling: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    size: PropTypes.string,
    layout: PropTypes.string,
    options: PropTypes.array.isRequired,
    personalLabelType: personalLabelProptypes,
    labelLayout: PropTypes.string.isRequired,
    renderKey: PropTypes.string.isRequired,
    defaultFontSize: PropTypes.number.isRequired,
    defaultFont: PropTypes.string.isRequired,
    defaultFontColor: PropTypes.string.isRequired,
    defaultBold: PropTypes.bool.isRequired,
    defaultItalic: PropTypes.bool.isRequired,
    defaultUnderline: PropTypes.bool.isRequired,
  };

  handleChange = option => ({ target: { checked } }) => {
    const {
      input: { value = [], onChange },
    } = this.props;
    const answer = checked
      ? [...value, option]
      : value.filter(item => item.id !== option.id);
    onChange(answer);
  };

  render() {
    const {
      input: { value },
      meta,
      size,
      layout,
      options,
      labelLayout,
      personalLabelType: labelType,
      renderKey,
      defaultFontSize,
      defaultFont,
      defaultFontColor,
      defaultBold,
      defaultItalic,
      defaultUnderline,
      styling,
    } = this.props;

    return (
      <div>
        <QuestionErrorMessage fieldMeta={meta} />
        <ImageQuestionGridContainer size={size} layout={layout}>
          {options.map((option, index) => (
            <CheckableLabeledImage
              key={option.id + renderKey} // TODO #001 Remove renderKey by updating RTE  @sinslav
              src={option.src}
              checkedColor={styling.selectionColor}
              e2e={'image-question-option'}
              content={getRichContentFromOptionModel(option)} // migrating plain to rich text @sinslav
              size={size} // need for IE11 css grid-support @sinslav
              layout={layout} // need for IE11 css grid-support @sinslav
              type={checkableInputTypes.checkbox}
              labelLayout={labelLayout}
              subLabel={getSubLabelByType({ labelType, index })}
              onChange={this.handleChange(option)}
              checked={!!find(value, { id: option.id })}
              defaultFontSize={defaultFontSize}
              defaultFont={defaultFont}
              defaultFontColor={defaultFontColor}
              defaultBold={defaultBold}
              defaultItalic={defaultItalic}
              defaultUnderline={defaultUnderline}
            />
          ))}
        </ImageQuestionGridContainer>
      </div>
    );
  }
}

export default compose(
  StylingTextOptionToRTEProps,
  withNewKeyOnLocalFontChange,
)(ImageMultiChoiceGroupField);
